import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

function Layout({ children }) {
  // useEffect(() => {
  //   document.body.classList.add('theme-default');
  // }, []);
  const tempCss = `
    /* ===== TEMP CSS (remove later) ===== */
    .unknown {
    background: rgba(255,0,0,0.3)
    }
  `;
  return (
    <div className="container-fluid p-0">
      <style>{tempCss}</style>
      <main className="main" id="top">
        <div className="d-flex">
          <Header />
          <Sidebar />
          <div className="content flex-grow-1" style={{ paddingLeft: '2.5rem', paddingRight: '2.5rem', marginLeft: '15.875rem' }}>
            <div className="pb-5">
              {children}
            </div>
            <Footer />
          </div>
        </div>
      </main>
    </div>
  );
}

export default Layout;
